export const LocaleConfig = {
  enabled: process.env.NEXT_PUBLIC_ENABLE_LOCALE === 'true',
};
